/* eslint-disable no-unused-vars */
export enum EBookingStatus {
    PENDING = 'PENDING',
    READY_FOR_PICKUP = 'READY_FOR_PICKUP',
    ACCEPTED = 'ACCEPTED',
    ARRIVED_AT_PICKUP = 'ARRIVED_AT_PICKUP',
    WAY_TO_DELIVER = 'WAY_TO_DELIVER',
    ARRIVED_AT_DELIVERY = 'ARRIVED_AT_DELIVERY',
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED',
    CANCELLED_BY_DRIVER = 'CANCELLED_BY_DRIVER',
    CANCELLED_BY_CUSTOMER = 'CANCELLED_BY_CUSTOMER',
    CANCELLED_BY_DELIVERY_PROVIDER = 'CANCELLED_BY_DELIVERY_PROVIDER',
    CANCELLED_BY_ADMIN = 'CANCELLED_BY_ADMIN',
    CANCELLED_BY_BUSINESS = 'CANCELLED_BY_BUSINESS',
    ON_HOLD = 'ON_HOLD',
    NOT_DELIVERED = 'NOT_DELIVERED',
    RETURNING = 'RETURNING',
    RETURNED = 'RETURNED',
    PROVIDER_NOT_FOUND = 'PROVIDER_NOT_FOUND',
}

export enum EOrigin {
    MANUAL = 'MANUAL',
    API = 'API',
    SPOONITY = 'SPOONITY',
    WOOCOMMERCE = 'WOOCOMMERCE',
    SHOPIFY = 'SHOPIFY',
    DELIVERECT = 'DELIVERECT',
    HUBSTER = 'HUBSTER',
    VTEX = 'VTEX',
    UBER_EATS = 'UBER_EATS',
    RAPPI = 'RAPPI',
}
